/* HBJ: drawer-script — (1) live WebwinkelKeur-cijfers in de compacte sterrenrij,
   (2) cross-sell eager laden in een open drawer (zie loadRecs).
   (1): live WebwinkelKeur-cijfers in de compacte drawer-sterrenrij.
   Leest score en aantal uit de shadow DOM van de verborgen <valued-widget>
   (snippets/hbj-drawer-reviews.liquid) en zet ze in de statische rij.
   Idempotent: de drawer-sectie wordt bij een cart-update volledig herrenderd
   (cart-drawer.js renderContents), daarom observeren we de sectie-container. */
(function () {
  if (window.hbjDrawerReviewsInit) return;
  window.hbjDrawerReviewsInit = true;

  function formatCount(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function syncOne(row) {
    var widget = row.querySelector('valued-widget');
    if (!widget || !widget.shadowRoot) return false;
    var rating = widget.shadowRoot.querySelector('.rating');
    var count = widget.shadowRoot.querySelector('.reviews .count');
    if (!rating || !count) return false;
    var r = rating.textContent.trim();
    var c = parseInt(count.textContent.replace(/\D/g, ''), 10);
    if (!r || !c) return false;
    var rEl = row.querySelector('[data-hbj-rating]');
    var cEl = row.querySelector('[data-hbj-count]');
    if (rEl) rEl.textContent = r;
    if (cEl) cEl.textContent = formatCount(c) + ' reviews';
    row.setAttribute('data-hbj-reviews', 'live');
    return true;
  }

  function sync(attempt) {
    attempt = attempt || 0;
    var rows = document.querySelectorAll('[data-hbj-reviews]:not([data-hbj-reviews="live"])');
    var pending = false;
    rows.forEach(function (row) { if (!syncOne(row)) pending = true; });
    if (pending && attempt < 20) setTimeout(function () { sync(attempt + 1); }, 500);
  }

  /* HBJ: cross-sell ("Maak je set compleet") eager laden in een open drawer.
     product-recommendations.js laadt lazy via IntersectionObserver. Op mobiel (390×664) staat het
     lege #cart-recommendations (0 px hoog) vaak net onder de zichtbare drawer-content — de sticky
     footer neemt de rest — en wordt dus nooit zichtbaar, dus nooit geladen (gemeten 18/10/2026).
     Daarom: bij openen en na elke herrender (cart-update, geneste terugval) direct init().
     init() is idempotent (data-hbj-loaded), dus een latere observer-trigger fetcht niet opnieuw. */
  function loadRecs() {
    var drawer = document.querySelector('cart-drawer[open]');
    if (!drawer) return;
    drawer.querySelectorAll('product-recommendations').forEach(function (el) {
      if (el.hasChildNodes() || typeof el.init !== 'function') return;
      el.init();
    });
  }

  function start() {
    sync();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('valued-widget').then(function () { sync(); });
      customElements.whenDefined('product-recommendations').then(function () { loadRecs(); });
    }
    document.addEventListener('on:cart-drawer:after-open', loadRecs);
    var section = document.getElementById('cart-drawer');
    section = section && section.closest('.shopify-section');
    if (section && window.MutationObserver) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { sync(); loadRecs(); }, 150);
      }).observe(section, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
